import { useEffect } from "react";

export default function JsonLd({ data, id }: { data: Record<string, unknown>; id: string }) {
  useEffect(() => {
    const script = document.createElement("script");
    script.type = "application/ld+json";
    script.id = id;
    script.text = JSON.stringify(data);
    document.head.appendChild(script);
    return () => {
      const existing = document.getElementById(id);
      if (existing) existing.remove();
    };
  }, [data, id]);

  return null;
}